import { AlertTriangle } from 'lucide-react';

interface FocusLossModalProps {
  onDismiss: () => void;
}

/**
 * Full-screen blocking overlay shown whenever the participant leaves the
 * competition window. Rendered by TurniejPage based on state from useAntiCheat.
 */
export const FocusLossModal = ({ onDismiss }: FocusLossModalProps) => (
  <div
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="focus-loss-title"
    aria-describedby="focus-loss-desc"
    className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/50 p-4 backdrop-blur-sm"
  >
    <div className="w-full max-w-md overflow-hidden rounded-3xl bg-white shadow-2xl">
      <div className="h-1 bg-gradient-to-r from-amber-400 via-orange-400 to-red-500" aria-hidden />

      <div className="px-6 py-7 text-center">
        <div
          className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full"
          style={{ backgroundColor: 'rgba(251, 191, 36, 0.15)' }}
        >
          <AlertTriangle className="h-7 w-7 text-amber-600" aria-hidden />
        </div>

        <h2 id="focus-loss-title" className="text-lg font-bold tracking-tight text-gray-800">
          Opuszczenie okna zostało zarejestrowane
        </h2>

        <p id="focus-loss-desc" className="mt-3 text-sm leading-relaxed text-gray-500">
          Opuszczenie okna przeglądarki lub przełączenie karty zostało automatycznie odnotowane
          i zapisane w systemie. Może to wpłynąć na wynik Twojego testu.
        </p>

        <button
          type="button"
          onClick={onDismiss}
          className="mt-6 w-full rounded-xl bg-competition-accent px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-competition-accent-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-competition-accent focus-visible:ring-offset-2"
        >
          Rozumiem, wróć do testu
        </button>
      </div>
    </div>
  </div>
);
